import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'src/app/modules/i18n/i18n.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  host: {
    "(window:click)": "onClick()"
  }
})
export class HeaderComponent implements OnInit {
  public urls: any = {};
  langFiles: any = {
    en: 'Dos_and_Donts_for_Citizens.pdf',
    hi: 'Dos_and_Donts_for_Citizens_Hindi.pdf',
    mr: 'Dos_and_Donts_for_Citizens.pdf',
    ml: 'Dos_and_Donts_for_Citizens.pdf',
    pb: 'Dos_and_Donts_for_Citizens.pdf',
    te: 'Dos_and_Donts_for_Citizens.pdf',
    gu: 'Dos_and_Donts_for_Citizens_Gujarati.pdf',
    as: 'Dos_and_Donts_for_Citizens.pdf',
    be: 'Dos_and_Donts_for_Citizens.pdf',
    ka: 'Dos_and_Donts_for_Citizens.pdf',
    or: 'Dos_and_Donts_for_Citizens_Odia.pdf',
    ta: 'Dos_and_Donts_for_Citizens_Tamil.pdf',
  };
  currLang = 'en';
  menuOpen = false;
  
  maxFontSizeAllowed = 0;
  minFontSizeAllowed = 0;
  dosDontsFileName: any = 'Dos_and_Donts_for_Citizens.pdf';
  constructor(
    public i18nService: I18nService,
    public translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.urls = environment.AppRedirectUrls;
    this.translate.onLangChange.subscribe((e: any) => {
      this.dosDontsFileName = this.langFiles[this.translate.currentLang];
      this.currLang = this.translate.currentLang;
    });

  }

  scroll(id: string) {
    console.log(`scrolling to ${id}`);
    const el: any = document.getElementById(id);
    el.scrollIntoView();
  }

  changeFontSize(event: any) {
    const buttonId = event.target.id;
    const textElements: any = document.querySelectorAll('.accessibility-plugin-ac');
    if (buttonId === 'increase-plugin-ac'){
      this.maxFontSizeAllowed = this.maxFontSizeAllowed + 1;
      if (this.minFontSizeAllowed > 0){
        this.minFontSizeAllowed = this.minFontSizeAllowed - 1;
      }

    }else if (buttonId === 'normal-plugin-ac'){
      this.maxFontSizeAllowed = 0;
      this.minFontSizeAllowed = 0;
    }else{
      this.minFontSizeAllowed = this.minFontSizeAllowed + 1;
      if (this.maxFontSizeAllowed > 0){
        this.maxFontSizeAllowed = this.maxFontSizeAllowed - 1;
      }
    }

    for (let i = 0; i < textElements.length; i++) {
      const fontsizevalue: any =  window.getComputedStyle(textElements[i], null).getPropertyValue('font-size');
      let currentFontSize: any;

      currentFontSize = parseInt(fontsizevalue.replace('px', ''));

      if (textElements[i].getAttribute('default-font-size') === null){

        const att = document.createAttribute('default-font-size');

        att.value = currentFontSize.toString();

        textElements[i].setAttributeNode(att);

      }

      if (buttonId === 'increase-plugin-ac'){

        currentFontSize = currentFontSize + 1;

      }else if (buttonId === 'normal-plugin-ac'){

        currentFontSize = textElements[i].getAttribute('default-font-size');

      }else{

        currentFontSize = currentFontSize - 1;

      }

      textElements[i].style.fontSize = currentFontSize + 'px';

    }
  

  }
  onClick(){
     this.menuOpen=false;
   
 }
 toggleClick($event:any){
  $event.stopPropagation();
   this.menuOpen=!this.menuOpen;
 }
}


